// src/components/ContactFooter.tsx
import React from 'react';
import './Footer.css';

interface ContactFooterProps {
    language: 'en' | 'fr';
}

export default function ContactFooter({ language }: ContactFooterProps) {
    // Objet de traduction pour les différentes colonnes
    const texts = {
        en: {
            contactTitle: "Contact Me",
            contactEmail: "julien.araujodasilva@gmail.com",
            contactLocation: "Clermont-Ferrand, France",
            followTitle: "Follow Me",
            workTitle: "Let's Work Together",
            workText:
                "If you'd like to discuss a project or just get in touch, feel free to send me a message.",
            cvButton: "Download my CV",
        },
        fr: {
            contactTitle: "Me Contacter",
            contactEmail: "julien.araujodasilva@gmail.com",
            contactLocation: "Clermont-Ferrand, France",
            followTitle: "Suivez-moi",
            workTitle: "Travaillons ensemble",
            workText:
                "Si vous souhaitez discuter d'un projet ou simplement me contacter, n'hésitez pas à m'envoyer un message.",
            cvButton: "Télécharger mon CV",
        },
    };

    const {
        contactTitle,
        contactEmail,
        contactLocation,
        followTitle,
        workTitle,
        workText,
        cvButton,
    } = texts[language];

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Colonne 1 : Me Contacter */}
                <div className="footer-column">
                    <h3 className="footer-title">{contactTitle}</h3>
                    <p className="footer-text">{contactEmail}</p>
                    <p className="footer-subtext">{contactLocation}</p>
                </div>

                {/* Colonne 2 : Suivez-moi */}
                <div className="footer-column">
                    <h3 className="footer-title">{followTitle}</h3>
                    <ul className="footer-link-list">
                        <li>
                            <a
                                href="https://github.com/JADS63/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                            >
                                GitHub
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://fr.linkedin.com/in/julien-araujo-da-silva-8b9ba92b0"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                            >
                                LinkedIn
                            </a>
                        </li>
                    </ul>
                </div>

                {/* Colonne 3 : Travaillons ensemble */}
                <div className="footer-column">
                    <h3 className="footer-title">{workTitle}</h3>
                    <p className="footer-text">{workText}</p>
                    <a href="/CV.pdf" download className="cv-button">
                        {cvButton}
                    </a>
                </div>
            </div>
        </footer>
    );
}
